import 'src/components/dataDisplay/Empty/Empty.css.ts.vanilla.css?source=LkVtcHR5X2VtcHR5Q29udGFpbmVyX19zbm5qNmcwIHsKICBwYWRkaW5nOiAyMHB4OwogIGJvcmRlci1yYWRpdXM6IDhweDsKfQ==';
export var emptyContainer = 'Empty_emptyContainer__snnj6g0';
export var emptyDescription = 'Empty_emptyDescription__snnj6g1';